import React from 'react'
import { NFT } from '@thirdweb-dev/sdk'
import styles from './index.module.scss'

interface NftDescriptionProps {
  nft: NFT
}

export const NftDescriptionHeader: React.FC = () => {
  return (
    <h1 className={ styles['nft-description__title'] } >
      Description
    </h1>
  )
}

export const NftDescriptionMain: React.FC<NftDescriptionProps> = ({ nft }) => {
  return (
    <p className={ styles['nft-description__text'] } >
      { nft.metadata.description }
    </p>
  )
}

export const NftDescription: React.FC<NftDescriptionProps> = ({ nft }) => {
  return (
    <div
      data-testid="nft-description"
      className={ styles['nft-description'] }
    >
      <NftDescriptionHeader/>

      <NftDescriptionMain nft={ nft }/>
    </div>
  )
}
